"use client"
import { HomepageDto, NewsletterSectionDto } from "api"
import ActionsSection from "./actionsSection/ActionsSection"
import HeroCarousel from "./heroCarousel/HeroCarousel"
import ModelShowcase from "./modelShowcase/ModelShowcase"
import Newsletter from "./newsletter/Newsletter"
import StoriesSection from "./storiesSection/StoriesSection"
import TopBanner from "./TopBanner/TopBanner"

type HomePageProps = {
  homepageData: HomepageDto
  newsLetterData: NewsletterSectionDto
}

const HomePage = ({ homepageData, newsLetterData }: HomePageProps) => {
  return (
    <>
      <div>
        <TopBanner data={homepageData.topBanner} />
      </div>
      <HeroCarousel data={homepageData.heroCarousel} />

      <ActionsSection data={homepageData.actionsSection} />

      <ModelShowcase data={homepageData.modelShowcase} />

      <StoriesSection data={homepageData.storiesSection} />

      {/* <SwiperMain
        ref={secondElementRef}
        carsStrip={homepageData.homePageCarsStrip}
      /> */}
      {/* <MazdaTools toolsData={homepageData.promotions} /> */}
      {/* <Blog blogData={homepageData.blogs} /> */}
      {newsLetterData && <Newsletter newsLetterData={newsLetterData} />}
    </>
  )
}

export default HomePage
